import {
    SCORE_BY_PATIENT
  } from "resources/ApiUrls"
  import MyAxiosInstance from "utils/MyAxiosInstance"
  
  const getAllByPatient = (patientId) => MyAxiosInstance.get(SCORE_BY_PATIENT(patientId))
  
  const scoresConst = { getAllByPatient }
  
  export default scoresConst
